import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
            内容分类
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            全网最全吃瓜地图
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大分类，覆盖娱乐圈、网红圈、直播圈所有热门话题，总有一款瓜适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group rounded-xl p-6 transition-all duration-300 hover:-translate-y-1 ${
                index === 0
                  ? 'bg-foreground-950 text-background-50'
                  : 'bg-background-50 border border-background-200/70'
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                index === 0
                  ? 'bg-foreground-800 text-background-50'
                  : 'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className={`text-lg font-heading font-bold mb-2 ${
                index === 0 ? 'text-background-50' : 'text-foreground-950'
              }`}>
                {cat.name}
              </h3>
              <p className={`text-sm ${
                index === 0 ? 'text-background-50/60' : 'text-foreground-600'
              }`}>
                {cat.description}
              </p>
              <div className={`mt-4 flex items-center gap-1 text-sm font-medium ${
                index === 0 ? 'text-background-50/80' : 'text-primary-500'
              }`}>
                查看全部
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}